var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.375 5.5V19.25C1.375 19.6147 1.51987 19.9644 1.77773 20.2223C2.03559 20.4801 2.38533 20.625 2.75 20.625H19.25C19.6147 20.625 19.9644 20.4801 20.2223 20.2223C20.4801 19.9644 20.625 19.6147 20.625 19.25V5.5H1.375ZM2.75 1.375C2.02065 1.375 1.32118 1.66473 0.805456 2.18046C0.289731 2.69618 0 3.39565 0 4.125L0 19.25C0 19.9793 0.289731 20.6788 0.805456 21.1945C1.32118 21.7103 2.02065 22 2.75 22H19.25C19.9793 22 20.6788 21.7103 21.1945 21.1945C21.7103 20.6788 22 19.9793 22 19.25V4.125C22 3.39565 21.7103 2.69618 21.1945 2.18046C20.6788 1.66473 19.9793 1.375 19.25 1.375H2.75Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8125 0C4.99484 0 5.1697 0.0724328 5.29864 0.201364C5.42757 0.330295 5.5 0.505164 5.5 0.6875V1.375C5.5 1.55734 5.42757 1.7322 5.29864 1.86114C5.1697 1.99007 4.99484 2.0625 4.8125 2.0625C4.63016 2.0625 4.4553 1.99007 4.32636 1.86114C4.19743 1.7322 4.125 1.55734 4.125 1.375V0.6875C4.125 0.505164 4.19743 0.330295 4.32636 0.201364C4.4553 0.0724328 4.63016 0 4.8125 0V0ZM17.1875 0C17.3698 0 17.5447 0.0724328 17.6736 0.201364C17.8026 0.330295 17.875 0.505164 17.875 0.6875V1.375C17.875 1.55734 17.8026 1.7322 17.6736 1.86114C17.5447 1.99007 17.3698 2.0625 17.1875 2.0625C17.0052 2.0625 16.8303 1.99007 16.7014 1.86114C16.5724 1.7322 16.5 1.55734 16.5 1.375V0.6875C16.5 0.505164 16.5724 0.330295 16.7014 0.201364C16.8303 0.0724328 17.0052 0 17.1875 0V0Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiCalendar);
export default __webpack_public_path__ + "static/media/biCalendar.7dad64e76634dd0c7644f4e87457d8b8.svg";
export { ForwardRef as ReactComponent };